import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../../angular-wallet-base/store/appState';
import { SubscriptionListenerComponent } from '../../angular-wallet-base/SubscriptionListenerComponent';
import { ModalController, NavController, Platform, ToastController } from '@ionic/angular';
import { AppModeService } from 'src/app/angular-wallet-base/services/app-mode.service';
import { getKeychain, getPTTokens } from '../../angular-wallet-base/store/wallet';
import { environment } from '../../../environments/environment';
import * as moment from 'moment';
import { AuthGuardService } from 'src/app/angular-wallet-base/services/auth-guard.service';

import {
  getTokenInfoArray,
  getTokenBalance,
  getTokenFiatValue,
  getCurrentNetworkLabel,
  getCurrentNetworkIcon,
  groupByTokenSymbol,
  openKycModal,
  numberFormatter,
  sortAssetList,
} from '../../angular-wallet-base/utils';
import { SmallToCryptoPipe } from '../../angular-wallet-base/pipes/smalltocrypto/smalltocrypto.pipe';
import BigNumber from 'bignumber.js';
import { TokenInfo, UnconfirmedTransaction } from '../../global';
import { getTokenKeyring, getUnconfirmedTxs } from '../../angular-wallet-base/store/wallet';
import { isNumeric } from 'rxjs/internal-compatibility';
import { ASSET_ALLOCATION_FEE, AUTH_REASON, EST_SYS_ASSET_NET_FEE, EST_SYS_NET_FEE } from '../../angular-wallet-base/constants';
import { createKeyringId } from '../../angular-wallet-base/keyringUtils';
import { NetworkService } from '../../angular-wallet-base/services/network.service';
import {
  ChartComponent,
  ApexAxisChartSeries,
  ApexChart,
  ApexXAxis,
  ApexDataLabels,
  ApexTooltip,
  ApexStroke,
  ApexResponsive,
  ApexGrid,
  ApexYAxis,
  ApexFill,
  ApexMarkers,
} from 'ng-apexcharts';
import { getBaseCurrency } from '../../angular-wallet-base/store/userPreferences';
import { SelectAssetModal, SelectTokenInfo } from '../select-asset-modal/select-asset-modal.component';
import { getToastPosition, openKYC, getCoinNameBySymbol } from 'src/app/angular-wallet-base/utils';
import { MembersPortalService } from 'src/app/angular-wallet-base/services/members-portal.service';
import { TranslateService } from '@ngx-translate/core';
import { SelectPaymentModal } from '../select-payment-modal/select-payment-modal';
import { getSideMenuStatus } from 'src/app/angular-wallet-base/store/appSettings';
import { take } from 'rxjs/operators';
import { TokenDefinitionService } from '../../angular-wallet-base/services/token-definition.service';
import { Router } from '@angular/router';
import { timer } from 'rxjs';
import { getGraphHomeState } from '../../angular-wallet-base/store/graphData';
import { BankAccountService } from 'src/app/angular-wallet-base/services/bank-account.service';
import { USDBalanceHomeModal } from './usd-balance-modal/usd-balance-modal';
import {
  GetBankAccountBalanceRequest,
  GetBankAccountRequestAction,
  GetBankAccountTransactionHistoryRequest,
  GetBankingHistoryAction,
} from 'src/app/angular-wallet-base/actions/bankAccount.actions';
import { getBankAccountBalance, getBankAssetsList } from 'src/app/angular-wallet-base/store/bankAccounts';
import { ComplianceService } from '../../angular-wallet-base/services/compliance.service';
import { Logger } from 'src/app/angular-wallet-base/services/logger.service';
import { RoutingService } from '../../angular-wallet-base/services/routing.service';

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  xaxis: ApexXAxis;
  yaxis: ApexYAxis;
  stroke: ApexStroke;
  tooltip: ApexTooltip;
  dataLabels: ApexDataLabels;
  responsive: ApexResponsive;
  grid: ApexGrid;
  fill: ApexFill;
  markers: ApexMarkers;
};

@Component({
  selector: 'prime-intro',
  templateUrl: 'prime.component.html',
  styleUrls: ['prime.component.scss'],
})
export class PrimePage extends SubscriptionListenerComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('chart', { static: false }) chart: ChartComponent;

  private isLodeEnabled = environment.features.linkLode;
  public totalBalance = 0;
  public groupedTokens;
  public tokens: TokenInfo[] = [];
  public tokenInfo: TokenInfo;
  public filteredTokens: any = [];
  public currentBaseCurrency: any;
  public aggregatedTokenEnabled = environment.features.aggregateTokens;
  public unconfirmedTxs: UnconfirmedTransaction[] = [];
  public baseToken = null;
  public guid;
  public transactionList = [];
  private sysBalance;
  public currentBalance;
  private sysTxRate;
  public currentTxNumber;
  public networkLabel;
  public baseChainName;
  public countdown: string;
  public interval: number;
  private completed: boolean;
  public chartOptions: Partial<ChartOptions>;
  public vaultChartOptions: Partial<ChartOptions>;
  public tradeChartOptions: Partial<ChartOptions>;
  public premiumChartOptions: Partial<ChartOptions>;
  public chartYAxis = ['1D', '1W', '1M', 'YTD', '1Y', 'ALL'];
  public activeYAxis = 5;
  public showChart = false;
  public waveSvg = 'vault';
  public activeOptionButton = 'ALL';
  public selectedDate = '';
  public isDesktopMode;
  public achUsdBalanceImg = '../../../assets/images/Group 4526@3x.png';
  public fiatBalance = 0;
  public tokenBalance = 0;
  public assetBalance = [];
  public updateOptionsData = {
    '1D': {
      xaxis: {
        min: moment().startOf('day').unix() * 1000,
        max: moment().endOf('day').unix() * 1000,
      },
    },
    '1W': {
      xaxis: {
        min: moment().subtract(7, 'days').unix() * 1000,
        max: new Date().getTime(),
      },
    },
    '1M': {
      xaxis: {
        min: moment().subtract(1, 'months').unix() * 1000,
        max: new Date().getTime(),
      },
    },
    YTD: {
      xaxis: {
        min: moment().startOf('year').unix() * 1000,
        max: new Date().getTime(),
      },
    },
    '1Y': {
      xaxis: {
        min: moment().subtract(1, 'years').unix() * 1000,
        max: new Date().getTime(),
      },
    },
    ALL: {
      xaxis: {
        min: undefined,
        max: undefined,
      },
    },
  };

  currentDate: any;
  targetDate: any;
  cDateMillisecs: any;
  tDateMillisecs: any;
  difference: any;
  seconds: any;
  minutes: any;
  hours: any;
  days: any;
  year: number = 2022;
  month: number = 11;
  months = ['Jan', 'Feb', 'Mar', 'April', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
  day: number = 31;
  offer: boolean = false;
  offerInterval;
  amountInterval;
  newMemberOfferData: any;
  newMember: boolean;
  timeData: string;
  applyPromo: boolean;

  public graphDataSet;
  public achLoadingSpinner: boolean;
  public assets;

  constructor(
    protected store: Store<AppState>,
    public modalController: ModalController,
    private membersPortalService: MembersPortalService,
    private smallToCrypto: SmallToCryptoPipe,
    private router: Router,
    private networkManager: NetworkService,
    private nav: NavController,
    private translate: TranslateService,
    public appMode: AppModeService,
    private authGuardService: AuthGuardService,
    private banking: BankAccountService,
    private routingService: RoutingService,
    private complianceService: ComplianceService,
    private platform: Platform
  ) {
    super(store);
    this.appMode.isDesktopMode.subscribe((mode) => (this.isDesktopMode = mode));
    const tabInstance = this;
    this.vaultChartOptions = {
      series: [
        {
          data: [],
        },
      ],
      chart: {
        width: '100%',
        height: this.isDesktopMode ? '330px' : 'auto',
        type: 'area',
        zoom: {
          enabled: false,
        },
        toolbar: {
          show: false,
        },
        animations: {
          enabled: true,
          easing: 'easeout',
          speed: 800,
          animateGradually: {
            enabled: true,
            delay: 150,
          },
          dynamicAnimation: {
            enabled: true,
            speed: 350,
          },
        },
      },
      markers: {
        colors: ['#FCA911'],
        strokeColors: '#FCA911',
      },
      grid: {
        show: false,
        padding: {
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: 'smooth',
        width: 1.8,
        lineCap: 'butt',
        colors: ['#FCA911'],
      },
      xaxis: {
        type: 'datetime',
        labels: {
          show: false,
          style: {
            colors: '#FCA911',
          },
        },
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
        crosshairs: {
          show: true,
          width: '1.2',
          position: 'back',
          opacity: 0.7,
          stroke: {
            color: '#FCA911',
            dashArray: 0,
          },
        },
      },
      yaxis: {
        crosshairs: {
          show: false,
        },
        show: true,
        showAlways: true,
        opposite: true,
        tickAmount: 2,
        floating: true,
        forceNiceScale: true,
        labels: {
          offsetX: 40,
          style: {
            fontSize: '15px',
            fontWeight: 500,
            colors: 'white',
            cssClass: 'apexcharts-yaxis-label',
          },
          formatter: (num): any => {
            return numberFormatter(num);
          },
        },
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
        tooltip: {
          enabled: false,
        },
      },
      tooltip: {
        enabled: true,
        custom({ series, seriesIndex, dataPointIndex, w }) {
          let date: HTMLElement = document.getElementById('graphBalance');
          date.innerHTML = tabInstance.selectedDate;
          return `<div class="apexcharts-tooltip-series-group apexcharts-active" style="order: 1; display: flex;flex-direction: column;background: #25333ee0;padding-top: 4px;">
                    <span class="tooltip-vault">${series[seriesIndex][dataPointIndex]} USD</span>
                  </div>`;
        },
        theme: 'dark',
        x: {
          format: 'dd MMM yyyy',
          formatter(value, { series, seriesIndex, dataPointIndex, w }) {
            tabInstance.selectedDate = new Date(value).toLocaleDateString();
            return '';
          },
        },
      },
      fill: {
        colors: ['#FCA911'],
        opacity: 0.4,
        type: 'gradient',
        gradient: {
          shade: 'dark',
          shadeIntensity: 1,
          type: 'vertical',
          gradientToColors: ['#FCA911', '#FCA911'],
          opacityFrom: 1,
          opacityTo: 0,
          stops: [0, 95, 100],
        },
      },
    };
  }

  getFiatAndAssetBalance() {
    //usd balance
    this.subscriptions.add(
      this.store.select(getBankAccountBalance).subscribe((balanceState) => {
        this.fiatBalance = balanceState.amount;
        this.totalBalance = this.fiatBalance + this.tokenBalance;
      })
    );
  }

  async getTransactionHistory(baseToken, guid) {
    this.baseToken = baseToken;
    this.guid = guid;

    const keyringId = createKeyringId(this.baseToken, this.guid);

    this.subscriptions.add(
      this.store.select(getTokenKeyring, { keyringId }).subscribe(async (keyring) => {
        // Logger.info('keyring update!');
        this.tokenInfo = {
          ...keyring,
          ...TokenDefinitionService.getTokenDefinition(createKeyringId(this.baseToken, keyring?.guid)),
        };
        this.transactionList = keyring.transactions ? [...keyring.transactions] : [];

        this.currentBalance = getTokenBalance(keyring);
      })
    );
    this.subscriptions.add(
      this.store.select(getUnconfirmedTxs).subscribe((txs) => {
        this.unconfirmedTxs = txs.filter((tx) => {
          return tx.tokenInfo.keyringId === this.tokenInfo.keyringId;
        });
        this.unconfirmedTxs.reverse();
      })
    );

    const sysKeyring = await this.store.select(getTokenKeyring, { keyringId: 'SYS' }).pipe(take(1)).toPromise();
    this.sysTxRate = sysKeyring.feePerAssetTx + ASSET_ALLOCATION_FEE;
    this.sysBalance = sysKeyring.balance;
    this.sysBalance = Number(this.sysBalance);
    const sysBalanceSmallCrypto = this.smallToCrypto.transform(this.sysBalance, { type: this.tokenInfo.baseChainSymbol });

    this.currentTxNumber = Math.floor(sysBalanceSmallCrypto / this.sysTxRate);
    this.networkLabel = await getCurrentNetworkLabel({
      tokenInfo: this.tokenInfo,
      networkManager: this.networkManager,
      translateService: this.translate,
    });
    this.baseChainName = getCoinNameBySymbol(this.tokenInfo.baseChainSymbol);
  }
  private getTime(): string {
    if (this.interval < 0) {
      this.interval = Math.abs(this.interval);
      this.completed = true;
    }
    const hours = Math.floor(this.interval / 3600);
    const minutes = Math.floor((this.interval - hours * 3600) / 60);
    const seconds = this.interval - hours * 3600 - minutes * 60;
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }
  private manipulateInterval() {
    this.interval--;
  }
  countdownCompleted() {
    this.completed = true;
    this.getMemberData();
  }
  async ngOnInit() {
    this.store.dispatch(new GetBankAccountBalanceRequest());
    this.store.dispatch(new GetBankAccountRequestAction());
    //need to remove
    this.store.dispatch(new GetBankAccountTransactionHistoryRequest());

    const bankingHistoryProgress = this.banking.bankingHistoryProgress.getValue();
    if (!bankingHistoryProgress) {
      this.store.dispatch(new GetBankingHistoryAction(true));
    }

    this.getMemberData();
    this.getFiatAndAssetBalance();

    this.store.select(getKeychain).subscribe(async (keychain) => {
      if (!keychain) {
        // Prevent error on wallet reset.
        return;
      }

      this.currentBaseCurrency = await this.store.select(getBaseCurrency).pipe(take(1)).toPromise();
    });

    this.subscriptions.add(
      this.store.select(getPTTokens).subscribe(async (assets) => {
        this.assets = assets.map((asset) => {
          asset.preciseBalance = this.smallToCrypto.transform(asset.balance, {
            type: asset.baseChainSymbol,
            precision: asset.precision
          });
          return asset;
        });

        this.tokenBalance = this.assets.reduce((acc, asset) => {
          return asset?.balance ? acc + (parseFloat(asset?.fiatValue) * parseFloat(asset?.preciseBalance)) : acc;
        }, 0);

        this.totalBalance = this.tokenBalance + this.fiatBalance;
      })
    );
  }

  ionViewDidEnter() {
    if (this.platform.is('cordova')) {
      this.store.dispatch(new GetBankAccountRequestAction());
      this.store.dispatch(new GetBankAccountTransactionHistoryRequest());
      this.getFiatAndAssetBalance();
    }
  }

  async getMemberData() {
    this.countdown = this.getTime();
    timer(1000, 1000).subscribe((val) => {
      this.manipulateInterval();
      this.countdown = this.getTime();
      if (this.interval === 0) {
        this.countdownCompleted();
      }
    });
    var newMemberPromo = await this.membersPortalService.getNewMemberPromoData();
    Logger.info(newMemberPromo.data.length);
    if (newMemberPromo.data.length == 0) {
      this.newMember = false;
    } else {
      this.newMemberOfferData = newMemberPromo.data[0];
      this.newMember = true;
      var hour = this.newMemberOfferData.timeRemaining.hours * 60 * 60;
      var min = this.newMemberOfferData.timeRemaining.minutes * 60;
      this.interval = hour + min + this.newMemberOfferData.timeRemaining.seconds;
    }
  }
  filterByTokenSymbol(objectArray, property) {
    return objectArray.reduce((acc, current) => {
      const x = acc.find((item) => item[property] === current[property]);
      if (!x && current.baseChainSymbol !== 'PT') {
        return acc.concat([current]);
      } else {
        return acc;
      }
    }, []);
  }

  async calculateAggregatedFiatBalance(aggregatedTokens) {
    if (aggregatedTokens instanceof Array) {
      let aggregatedFiatBalance = 0;
      aggregatedTokens.forEach((token) => {
        if (token.fiatValue) {
          let num = Number(token.fiatValue || 0) * Number(token.balance || 0);
          num = this.smallToCrypto.transform(num, { type: token.baseChainSymbol, precision: token.precision });
          aggregatedFiatBalance += new BigNumber(num).toNumber();
        }
      });
      return aggregatedFiatBalance;
    }
  }

  calculateAggregatedBalance(groupedTokens, symbol, fiatVal) {
    const aggregatedTokens = groupedTokens[symbol];
    if (aggregatedTokens instanceof Array) {
      let aggregateTotal = {
        aggregatedBalance: 0,
        aggregatedFiatBalance: 0,
      };
      // let aggregatedBalance = 0;
      aggregatedTokens.forEach((token) => {
        if (token.balance) {
          let numBalance = this.smallToCrypto.transform(token.balance, {
            type: token.baseChainSymbol,
            precision: token.precision,
          });
          token['preciseBalance'] = numBalance;
          aggregateTotal.aggregatedBalance += new BigNumber(numBalance).toNumber();
          // let fiatBalance =
        }
        if (token.fiatValue) {
          let num = Number(token.fiatValue || 0) * Number(token.balance || 0);
          num = this.smallToCrypto.transform(num, { type: token.baseChainSymbol, precision: token.precision });
          aggregateTotal.aggregatedFiatBalance += new BigNumber(num).toNumber();
        }
        if (!token.fiatValue) {
          token['fiatValue'] = fiatVal;
        }
      });
      return aggregateTotal;
    }
  }

  getTokenFiatValue(fiatRate, balance) {
    return getTokenFiatValue(fiatRate, balance);
  }

  getTokenBalanceOfToken(token: any) {
    return this.aggregatedTokenEnabled
      ? token.aggregateTotalBalance
      : this.smallToCrypto.transform(token.balance, { type: token.baseChainSymbol, precision: token.precision });
  }

  getAssetBalance(token: any) {
    var result = this.smallToCrypto.transform(token.balance, { type: token.baseChainSymbol, precision: token.precision });
    return result;
  }

  ngOnDestroy() {
    clearTimeout(this.offerInterval);
    clearTimeout(this.amountInterval);
  }

  initChart() {
    this.vaultChartOptions.series[0].data = this.graphDataSet;
    this.chartOptions = this.vaultChartOptions;
    this.showChart = true;
    setTimeout(() => {
      this.updateOptions('ALL');
    }, 1000);
  }

  changeWallet(wallet: string) {
    this.waveSvg = wallet;
    switch (wallet) {
      case 'trade':
        this.chartOptions = this.tradeChartOptions;
        break;
      case 'premium':
        this.chartOptions = this.premiumChartOptions;
        break;
      default:
        this.waveSvg = 'vault';
        this.chartOptions = this.vaultChartOptions;
    }
  }

  public updateOptions(option: any): void {
    this.selectedDate = '';
    this.activeOptionButton = option;
    this.chart.updateOptions(this.updateOptionsData[option], false, true, true);
  }

  resetChart() {
    this.activeOptionButton = 'ALL';
    this.selectedDate = '';
    this.showChart = false;
    this.initChart();
  }

  ngAfterViewInit() {}

  async isExpandChange(i, item, shouldOpen) {
    if (item?.tokens?.length > 0 && !['BTC', 'ETH', 'SYS', 'SOL', 'AVAX'].includes(item.symbol)) {
      this.tokens[i]['isExpanded'] = !this.tokens[i]['isExpanded'];
    } else {
      await this.getTransactionHistory(item.baseChainSymbol, item.assetGuid);
      const token = item;
      const unconfirmedTxs = this.unconfirmedTxs;
      this.authGuardService.setTokenData({ tokenInfo: token, unconfirmedTxs });
      this.router.navigate(['/ach/token-page']);
    }
  }

  formatNumber(num = '') {
    if (isNumeric(num)) {
      const value = Number(num); // new BigNumber(num).toNumber();
      if (Math.abs(value) > 999) {
        const absValue = Math.sign(value) * (Math.abs(value) / 1000);
        return Math.floor(absValue * 100) / 100 + 'k';
      }
      return Math.sign(value) * Math.abs(value);
    }
    return 0;
  }

  parseBaseChainSymbol(chain) {
    switch (chain) {
      case 'SYS':
        return 'Syscoin';
      case 'SOL':
        return 'Solana';
      case 'HL':
        return 'HyperLedger';
      case 'AVAX':
        return 'Avalanche';
      case 'ETH':
        return 'Ethereum';
      default:
        return 'Unknown';
    }
  }

  async isExpandChangeChild(item) {
    await this.getTransactionHistory(item.baseChainSymbol, item.guid);
    const token = this.tokenInfo;
    const unconfirmedTxs = this.unconfirmedTxs;
    this.authGuardService.setTokenData({ tokenInfo: token, unconfirmedTxs });
    this.router.navigate(['/ach/token-page']);
  }

  async presentModal(mode: string) {
    this.modalController.dismiss();
    if (mode == 'buyAch') {
      var kycData = await this.complianceService.getKycCip();
      if (!kycData['passingLevel']) {
        const sideMenuHidden = await this.store.select(getSideMenuStatus).pipe(take(1)).toPromise();
        await openKycModal(sideMenuHidden, this.isDesktopMode, this.modalController, 'prime');
        return;
      }
    }

    const sideMenuHidden = await this.store.select(getSideMenuStatus).pipe(take(1)).toPromise();

    let cssClass = '';
    cssClass += this.isDesktopMode ? 'select-asset-modal-desktop' : 'select-asset-modal';
    cssClass += !sideMenuHidden && this.isDesktopMode ? ' with-side-menu' : '';

    const modal = await this.modalController.create({
      component: SelectAssetModal,
      componentProps: {
        actionType: mode,
        newMember: this.applyPromo == true ? true : false,
        promocode: this.applyPromo == true ? this.newMemberOfferData.attributes.code : null,
      },
      cssClass,
      initialBreakpoint: this.isDesktopMode ? undefined : 0.9,
      breakpoints: this.isDesktopMode ? undefined : [0, 0.6, 0.9, 1],
    });
    await modal.present();
    await modal.onDidDismiss().then();
  }
  async openUsdBalance() {
    await this.goToAchBanking();
  }
  async goBack() {
    await this.routingService.goHome();
  }
  async goToAchBanking() {
    const sideMenuHidden = await this.store.select(getSideMenuStatus).pipe(take(1)).toPromise();
    let cssClass = '';
    cssClass += this.isDesktopMode ? 'usd-balance-home-modal-desktop' : 'usd-balance-home-modal';
    cssClass += !sideMenuHidden && this.isDesktopMode ? ' with-side-menu' : '';
    const modal = await this.modalController.create({
      component: USDBalanceHomeModal,
      cssClass,
    });
    return await modal.present();
  }
}
